class ImageGridHelper {
  static reSort = (oldIndex, newIndex, images) => {
    if (oldIndex === newIndex) return images;
    const smallestChangedIndex = Math.min(oldIndex, newIndex);
    const largestChangedIndex = Math.max(oldIndex, newIndex);

    const unchangedImages = images
      .slice(0, smallestChangedIndex)
      .concat(images.slice(largestChangedIndex + 1));

    const movedImage = { ...images[oldIndex], order: newIndex };

    const shouldShiftAffectedImagesUp = oldIndex < newIndex;

    const affectedImages = shouldShiftAffectedImagesUp
      ? images.slice(oldIndex + 1, newIndex + 1)
      : images.slice(newIndex, oldIndex);

    const changeImageOrder = shouldShiftAffectedImagesUp
      ? (previousOrder) => previousOrder - 1
      : (previousOrder) => previousOrder + 1;

    const reorderedAffectedImages = affectedImages.map((image) => ({
      ...image,
      order: changeImageOrder(image.order)
    }));

    return unchangedImages
      .concat([movedImage])
      .concat(reorderedAffectedImages)
      .sort((firstElement, secondElement) =>
        firstElement.order < secondElement.order ? -1 : 1
      );
  };
}

export default ImageGridHelper;
